/* eslint-disable */
import { filePreviewOpenRequest } from '@/services/file-preview'
import { Options, Vue } from 'vue-class-component'
import { Subscription } from 'rxjs'
import utilityService from '@/services/utility-service'
import PdfPreview from '@/components/FilePreview/PdfPreview/PdfPreview.vue'
import i18n from '@/i18n'

@Options({
  components: {
    PdfPreview
  }

})
export default class PreviewHandler extends Vue {
  subscription: Subscription | null = null;
  file={
    url:'',
    name:''
  };
  previewLoader = false;
  showPanel = false;

  mounted () {
  this.$watch(() => this.showPanel, (val: boolean) => {
      if (val) {
        this.lockScroll()
      } else {
        this.unlockScroll()
      }
    })

    this.subscription = filePreviewOpenRequest.subscribe(({ fileUrl , name }) => {
      this.file={
        url: fileUrl,
        name: name
      };
      this.$nextTick(() => {
        this.showPanel = true
        this.previewLoader = true
      })
    })
  }

  beforeDestroy () {
    this.subscription?.unsubscribe()
  }

  previewError () {
    this.closeDrawer()
    utilityService.showToast(
      i18n.global.t('default.alert.no_preview'),
      'error',
      'preview-error'
    )
  }

  closeDrawer () {
    this.previewLoader = false
    this.file = {
      url: '',
      name: ''
    }
    this.showPanel = false
  }

  closeHandler () {
    this.closeDrawer()
  }

  private lockScroll () {
    document.documentElement.classList.add('no-scroll')
    document.body.classList.add('no-scroll')
  }

  private unlockScroll () {
    document.documentElement.classList.remove('no-scroll')
    document.body.classList.remove('no-scroll')
  }
}
